import { render, staticRenderFns } from "./mat_change.vue?vue&type=template&id=41533130&scoped=true&"
import script from "./mat_change.vue?vue&type=script&lang=js&"
export * from "./mat_change.vue?vue&type=script&lang=js&"
import style0 from "./mat_change.vue?vue&type=style&index=0&id=41533130&scoped=true&lang=less&"
import style1 from "./mat_change.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41533130",
  null
  
)

export default component.exports